// Loads the official Razorpay Checkout script on demand.
let scriptPromise = null;

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => { scriptPromise = null; reject(new Error("Failed to load Razorpay")); };
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// Opens Razorpay Checkout for an already-created server order.
// Resolves with the handler payload on success, or null if dismissed.
export function openRazorpayCheckout(order) {
  return new Promise(async (resolve, reject) => {
    try {
      await loadRazorpayScript();
    } catch (e) {
      return reject(e);
    }
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: Math.round(order.amount * 100),
      currency: "INR",
      name: "Instant Paisa",
      description: "Processing Fee Payment",
      order_id: order.razorpay_order_id,
      prefill: order.prefill || {},
      theme: { color: "#0b3d2e" },
      handler: (resp) => resolve(resp),
      modal: { ondismiss: () => resolve(null) },
    });
    rzp.on("payment.failed", (resp) => reject(new Error(resp?.error?.description || "Payment failed")));
    rzp.open();
  });
}
